import { Component, input, InputSignal, OnChanges, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ProductCardSkeletonComponent } from '../../product-card';

@Component({
  selector: 'ui-product-list-skeleton',
  templateUrl: './product-list-skeleton.component.html',
  styleUrls: ['./product-list-skeleton.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    ProductCardSkeletonComponent,
  ],
})
export class ProductListSkeletonComponent implements OnInit, OnChanges {
  public count: InputSignal<number> = input(6);

  public renderArray: number[] = [];

  public ngOnInit(): void {
    this.fillArray();
  }

  public ngOnChanges(): void {
    this.fillArray();
  }

  private fillArray(): void {
    this.renderArray = new Array<number>(this.count()).fill(0);
  }
}
